import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgArrowRight({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 12 12"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M5.1.8l.6-.6a.64.64 0 01.9 0l5.21 5.21c.25.25.25.66 0 .9l-5.2 5.21a.64.64 0 01-.91 0l-.6-.59a.64.64 0 01.01-.92l3.23-3.07H.64A.64.64 0 010 6.29v-.85c0-.36.29-.65.64-.65h7.7L5.11 1.72a.64.64 0 010-.92z" />
    </svg>
  );
}

SvgArrowRight.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgArrowRight.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgArrowRight svgRef={ref} {...props} />);
export default ForwardRef;
